
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage, ElMessageBox } from "element-plus"
import { CardSeries } from "@/store/modules/CardSeriesModule"

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("卡牌系列列表", ["抽卡系统"])
    })

    const store = useStore()
    const tableData = ref<CardSeries[]>([])

    const formData = ref({
      name: '',
      enabled: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const query = () => {
      store
        .dispatch(Actions.GET_CARD_SERIES_LIST, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentCardSeriesList
          page.value.totalResult = store.getters.currentCardSeriesCount
        })
        .catch(() => {
          ElMessage.error('获取系列列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        name: '',
        enabled: ''
      }
      page.value.currentPage = 1
      query()
    }

    const onSortChange = (row: CardSeries) => {
      store
        .dispatch(Actions.UPDATE_CARD_SERIES, {
          id: row.id,
          values: { sort: row.sort }
        })
        .then((data: { success: boolean; error_msg?: string }) => {
          if (data.success) {
            ElMessage.success('排序已更新')
            query()
          } else {
            ElMessage.error(data.error_msg || '更新排序失败')
          }
        })
        .catch(() => {
          ElMessage.error('更新排序失败')
        })
    }

    const onDelete = (row: CardSeries) => {
      ElMessageBox.confirm(
        `确定要删除系列「${row.name}」吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          store
            .dispatch(Actions.DELETE_CARD_SERIES, row.id)
            .then((data: { success: boolean; error_msg?: string }) => {
              if (data.success) {
                ElMessage.success('删除成功')
                query()
              } else {
                ElMessage.error(data.error_msg || '删除失败')
              }
            })
            .catch(() => {
              ElMessage.error('删除失败')
            })
        })
        .catch(() => {
          // 取消删除
        })
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      onSortChange,
      onDelete
    }
  },
})
